// /src/components/core/HeadersAndFooters/FooterButtonsList.jsx
// Footer buttons overlay for list/management pages
// Used by: MyLocations, MyArticles, MyTags
// Buttons: Go to Top (for scrollable lists, only shows when page is scrolled)

import { useState, useEffect } from 'react';
import StandardButton from '../StandardButton';
import { useTranslation } from '../../../i18n/useTranslation';

/**
 * FooterButtonsList Component
 *
 * Provides footer for user data management pages with scrollable lists.
 * Shows "Go to Top" button only when page is scrolled down.
 *
 * Props:
 * @param {Boolean} showGoToTop - Show Go to Top button (default: true)
 */
function FooterButtonsList({ showGoToTop = true }) {
  const { t } = useTranslation('ui');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button if scrolled more than 100px from top
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    // Check initial scroll position
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGoToTopClick = () => {
    console.log('Go to Top button clicked');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 40px',
      paddingRight: '130px' // Account for Help button on right (50px + 40px + 40px spacing)
    }}>

      {/* Left Section - Reserved for future */}
      <div style={{ display: 'flex', gap: '16px' }}>
        {/* Future: Filter or sort buttons */}
      </div>

      {/* Center Section - Go to Top */}
      <div style={{ display: 'flex', gap: '16px' }}>
        {showGoToTop && isScrolled && (
          <StandardButton
            variant="action"
            iconName="ArrowUp"
            label={t('go_to_top')}
            onClick={handleGoToTopClick}
          />
        )}
      </div>

      {/* Right Section - Reserved for future */}
      <div style={{ display: 'flex', gap: '16px' }}>
        {/* Future: Export or other actions */}
      </div>

    </div>
  );
}

export default FooterButtonsList;
